export default "__VITE_ASSET__CMGXPRev__"